<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container">
      <div class="container-fluid">
        <div class="row">
        	<div class="col-md-2">
            <smallBar></smallBar>
          </div>
          <div class="col-md-10">
				    <div class="widget-wrap">
				    	<h4>收支分類管理</h4>
				    	<div class="row">
				    		<div class="col-md-4">
				    			<div class="card">
				    				<h4>收入分類</h4>
				    				<div class="card-body text-left pl-3 pr-3 pb-3">
				    					<Container
								        @drop="onColumnDrop($event,'income')"
								        drag-handle-selector=".column-drag-handle"
								        @drag-start="dragStart"
								        :lock-axis="'y'"
								        v-if="filteCategoriesByType('income').length != 0"
								      >
								        <Draggable v-for="category in categories" v-if="category.money_type == 'income'" :key="category.id">
				    							<div class="column-drag-handle p-3 alert alert-info">
				    								<div class="media">
				    									<div class="media-body">

				    										<input class="form-control" v-bind:ref="('category'+category.id)" v-model="category.name" 
                                  v-if="canEditColumn('category',category.id)"
                                  @keydown.enter="$event.target.blur()" 
                                  v-on:blur="updateCategory(category)"
                                >
                                <p class="pointer relative pr-5" v-else>
                                	<span @click="editColumn('category',category.id)" class="btn-block" v-if="category.name == ''">新分類 <i class="fa fa-pencil-alt"></i></span>
                                  <span @click="editColumn('category',category.id)" class="btn-block" v-else>{{category.name}} <i class="fa fa-pencil-alt"></i></span>
                                  
                                </p>
				    									</div>
				    									<button class="btn btn-xs btn-danger mt-0" @click="temp_money_category= category;deleteMoneyCategoryModal=true;">
				    										<i class="fa fa-trash"></i>
				    									</button>
				    								</div>
				    							</div>
						    				</Draggable>
						    			</Container>
						    			<p class="text-center p-3 alert alert-info" v-else>
						    				沒有資料
						    			</p>
						    			<div @click="createCategory('income')" class="btn btn-default btn-block text-center pointer pt-2 pb-2">
						    				<i class='fa fa-plus'></i> 建立收入項目
						    			</div>
				    				</div>
				    			</div>
				    		</div>
				    		<div class="col-md-4">
				    			<div class="card">
				    				<h4>支出分類</h4>
				    				<div class="card-body text-left pl-3 pr-3 pb-3">
				    					<Container
								        @drop="onColumnDrop($event,'expend')"
								        drag-handle-selector=".column-drag-handle"
								        @drag-start="dragStart"
								        :lock-axis="'y'"
								        v-if="filteCategoriesByType('expend').length != 0"
								      >
								        <Draggable v-for="category in categories" v-if="category.money_type == 'expend'" :key="category.id">
				    							<div class="column-drag-handle p-3 alert alert-info">
				    								<div class="media">
				    									<div class="media-body">

				    										<input class="form-control" v-bind:ref="('category'+category.id)" v-model="category.name" 
                                  v-if="canEditColumn('category',category.id)"
                                  @keydown.enter="$event.target.blur()" 
                                  v-on:blur="updateCategory(category)"
                                >
                                <p class="pointer relative pr-5" v-else>
                                	<span @click="editColumn('category',category.id)" class="btn-block" v-if="category.name == ''">新分類 <i class="fa fa-pencil-alt"></i></span>
                                  <span @click="editColumn('category',category.id)" class="btn-block" v-else>{{category.name}} <i class="fa fa-pencil-alt"></i></span>
                                  
                                </p>
				    									</div>
				    									<button class="btn btn-xs btn-danger mt-0" @click="temp_money_category= category;deleteMoneyCategoryModal=true;">
				    										<i class="fa fa-trash"></i>
				    									</button>
				    								</div>
				    							</div>
						    				</Draggable>
						    			</Container>
						    			<p class="text-center p-3 alert alert-info" v-else>
						    				沒有資料
						    			</p>
						    			<div @click="createCategory('expend')" class="btn btn-default btn-block text-center pointer pt-2 pb-2">
						    				<i class='fa fa-plus'></i> 建立支出項目
						    			</div>
				    				</div>
				    			</div>
				    		</div>
				    	</div>
				    </div>
          </div>
        </div>
      </div>
    </section>
    <div v-if="deleteMoneyCategoryModal">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="deleteMoneyCategoryModal=false;resetTempMoneyCategory()">
          <div class="modal-container modal-center col-md-6" @click.stop>
            <div class="modal-header" style="display:block">
            	<h4>
              	刪除 {{temp_money_category.name}}
              </h4>
              <a href="#" class="btn-close" @click="deleteMoneyCategoryModal=false;resetTempMoneyCategory()">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms">
              <div>
                <div class="form">
                	<p class="alert alert-info">
                		刪除分類不會影響收支項目，也不會影響已規劃的年度預算
                	</p>
                  <div class="text-center">
	                  <button class="btn btn-danger" @click="deleteMoneyCategory()" v-if="temp_money_category.loading==false">確定刪除</button>
	                  <button class="btn btn-danger" v-else>刪除中</button>
	                  <button class="btn btn-default" @click="newMoneyCategoryModal = false;resetTempMoneyCategory()">取消</button>
	                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'
import smallBar from './SmallBar.vue';
import moment from 'moment';
import { Container, Draggable } from "vue-smooth-dnd";
import { applyDrag, generateItems } from '../../utils/dragHelpers'
import { getArrayItemById, getArrayItem } from '../../utils/commonHelpers'

export default {
  name: 'money_categories',
  data() {
    return {
    	newMoneyCategoryModal: false,
    	deleteMoneyCategoryModal: false,
    	temp_money_category: {},
    	categories: [],
    	editColumnName: "",
    	editColumnId: "",
    	upperDropPlaceholderOptions: {
        className: 'cards-drop-preview',
        animationDuration: '150',
        showOnTop: true
      },
    }
  },
  created() {
    this.getCategories()
    this.resetTempMoneyCategory()
  },
  components: {
    smallBar,Container, Draggable
  },
  props: ['toggle_aside'],
  methods: {
  	filteCategoriesByType(type){
      return this.categories.filter(m => m.money_type == type)
    },
    getCategories(){
      let vm = this
      this.axios.get('finances/money_categories')
      .then(function(response) {
        if (response.status == 200) {
          vm.categories = response['data']['data']['money_categories']
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    createCategory(type){
    	const vm = this;
    	vm.temp_money_category.loading = true
    	vm.temp_money_category.money_type = type

      this.axios.post('finances/money_categories', {
        money_category: vm.temp_money_category,
      })
      .then(function(response) {
        if (response.status == 200 && response['data']['status']== 'success') {
          vm.categories.push(response['data']['data']['current_object'])
          vm.editColumn('category',parseInt(response['data']['data']['current_object']['id']))
          vm.resetTempMoneyCategory()
          vm.temp_money_category.loading = false

        } else {
        	vm.temp_money_category.loading = false
        	vm.$toastr.w('無法建立，請稍後再試，已通知工程師進行問題排除!')
        }
      })
      .catch(function(error) {
      	vm.temp_money_category.loading = false
      	vm.$toastr.w('無法建立，請稍後再試，已通知工程師進行問題排除')
      });
    },
    updateCategory(category){
			let vm = this
			vm.finishedEditColumn()
      this.axios.put('finances/money_categories/'+category.id, {
        money_category: category,
      })
      .then(function(response) {
        if (response.status == 200) {
         
        } else {
        	vm.$toastr.w('無法更新，請稍後再試，已通知工程師進行問題排除!')
          console.log(response)
        }
      })
      .catch(function(error) {
      	vm.$toastr.w('無法更新，請稍後再試，已通知工程師進行問題排除!')
        console.log('error:', error)
      });
    },
    deleteMoneyCategory(){
    	// delete in html
    	let vm = this;
    	vm.temp_money_category.loading = true
      this.axios.delete('finances/money_categories/'+vm.temp_money_category.id, {
      })
      .then(function(response) {
        if (response.status == 200 && response['data']['status']== 'success') {
        	var index = vm.categories.indexOf(vm.temp_money_category)
		      vm.categories.splice(parseInt(index), 1)
		      vm.deleteMoneyCategoryModal = false
		      vm.resetTempMoneyCategory()
        } else {
        	vm.temp_money_category.loading = false
          vm.$toastr.w('無法刪除，請稍後再試，已通知工程師進行問題排除')
        }
      })
      .catch(function(error) {
      	vm.temp_money_category.loading = false
        vm.$toastr.w('無法刪除，請稍後再試，已通知工程師進行問題排除')
      });
    },
    resetTempMoneyCategory(){
      let vm = this
      vm.temp_money_category = {
        id: '',
        name: '',
        money_type: 'income',
        order: '999',
        loading: false,
      }
    },
    canEditColumn(colmn_name,id){
      let vm = this
      if(vm.editColumnName == colmn_name && vm.editColumnId == id){
        return true
      }else{
        return false
      }
    },
    editColumn(name,id){
      let vm = this
      this.editColumnName = name
      this.editColumnId = id
      this.$nextTick(() => {
        if (Array.isArray(vm.$refs[name+id])){
          vm.$refs[name+id][0].focus()
        }else{
          vm.$refs[name+id].focus()
        }
      })
    },
    finishedEditColumn(){
      this.editColumnName = ""
      this.editColumnId = ""
    },
    onColumnDrop (dropResult,type) {
      let vm = this
      vm.categories = applyDrag(vm.categories, dropResult)
      //ajax 更新order
      console.log('dropResult',dropResult)
      console.log('vm.categories',vm.categories)
      this.axios.post('finances/money_categories/update_order', {
        categories: vm.filteCategoriesByType(type),
        type: type,
      })
      .then(function(response) {
        if (response.status == 200 && response['data']['status']== 'success') {
          
        } else {
        	vm.$toastr.w('更新失敗，已通知管理員進行障礙排除，請稍後再試')
          
        }
      })
      .catch(function(error) {
      	vm.$toastr.w('更新失敗，已通知管理員進行障礙排除，請稍後再試')
        
      });
    },
    dragStart () {
      // console.log('drag started')
    },
  }
}
</script>


// WEBPACK FOOTER //
// MoneyCategories.vue?09df48e9